import { EntityStore } from '../../../shared/stores/EntityStore';
import { action, makeObservable } from 'mobx';
import { api } from '../../../shared/api/api';

class TagStore extends EntityStore {
	constructor() {
		super('tags');
		makeObservable(this);
	}

	@action
	async getTags(query) {
		const url = this.entityPluralEndpoint + '?q=' + query;
		const result = await api.get(encodeURI(url));
		return result;
	}
}

export const tagStore = new TagStore();
